<div id="wrap" class="practiceList-bgblue">
  <div class="common-back-btn-sight" id="closeBtn"  (click)="close()" *ngIf="isOpenClass==0&& type!== 'huatek' && !isTencent">
    <span>×</span>
  </div>

  <div id="head_wrap" class="fontSize18">
    情景模拟
  </div>

  <!-- 提醒 -->
  <app-com-tip *ngIf="isShowToast" [type]="'toast'" [desText]="promptText" [cancelText]="''" [sureText]="''" ></app-com-tip>

 <div *ngIf="practiceList">
    <div class="practiceList-listeImgItem" [ngStyle]="{'background-image': practice.extends ? practice.extends.bg : '' }" *ngFor="let practice of practiceList;let i = index" (click)="goToNextStep(i)">
			<div class="practiceList-listeImgItemHead-Img">

				<img *ngIf="practice.extends && practice.extends.userPhoto != ''" src="{{practice.extends.userPhoto}}" class="practiceList-icon"  />
				<div *ngIf="practice.status == 2" class="practice-status">
					已完成
				</div>
			</div>
			<div class="practiceList-listeImgItemHead fontSize16">
				{{practice.title}}
			</div>
			<div class="practiceList-listeImgItemContent fontSize14 lineHeight21">
				{{practice.description}}
				<div class="entryBtn">进入</div>
			</div>
		</div>

   <div class="approachModuleWrap" [ngClass]="type === 'huatek'? 'active':'' " *ngIf="!isCustomLock&&isShowApproach&&showGoToSurveyBtn&&isOpenClass==0&&isShowQuestionnaire&&learningPathMetaId!==403&&learningPathMetaId!==413 && !isTencent">
     <component-approach [theme]="approachTheme" [isFirst]="isShowQuestionnaire" (onGoCourse)="goToPostSurvey()"></component-approach>
   </div>

   <div class="approachModuleWrap" [ngClass]="type === 'huatek'? 'active':'' " *ngIf="!isCustomLock&&isShowApproach&&showGoToSurveyBtn&&isOpenClass==0&&!isShowQuestionnaire&&learningPathMetaId!==403&&learningPathMetaId!==413 && !isTencent">
     <component-approach [theme]="approachTheme" [isFirst]="isShowQuestionnaire" (onGoCourse)="goToPostSurvey()"></component-approach>
   </div>

  </div>
  <!--<div  *ngIf="!learningTour && finished"  id="surveyWrap">
    <p [innerHtml]="chuanjie" class="fontSize16 lineHeight21"></p>
  </div>

  -->
<!--	<div id="surveyBtn" (click)="goToPostSurvey()" *ngIf="showGoToSurveyBtn&&isOpenClass==0" class="fontSize16">-->
<!--    进入能力考核-->
<!--  </div>-->
</div>
<!--<div id="nextWrap" [ngClass]="{'nextWrapAfter': finishStatus == true,-->
<!--                               'nextWrapBefore': finishStatus == false}" (click)="finish()">-->
<!--   <div id="nextStudy" *ngIf="finishStatus" class="nextStudy fontSize16">-->
<!--     已完成本能力的学习-->
<!--   </div>-->
<!--   <div id="nextStudy" *ngIf="!finishStatus" class="nextStudy fontSize16">-->
<!--     完成本能力的学习-->
<!--   </div>-->
<!--</div>-->

<app-questionnaire [enter]="1"  [learningPathMetaId]="learningPathMetaId" [isShowQuestionnaire]="isShowQuestionnaire && !type && !isTencent" (onExit)="closeQuestionnaire()"></app-questionnaire>



// WEBPACK FOOTER //
// ./src/app/case-practice-authorization-list/case-practice-authorization-list.component.html